import WebSocketAsPromised from "websocket-as-promised";

import {
  RC_CHECK_STATE,
  RC_CLOSE,
  RC_CONNECT,
  RC_DISCONNECT,
  RC_ERROR,
  RC_LOGIN,
  RC_MESSAGE_ALL,
  RC_MESSAGE_NEW,
  RC_MESSAGE_UNREAD,
  RC_METHOD,
  RC_NOTIFICATION,
  RC_OPEN,
  RC_REQUEST,
  RC_RESPONSE,
  RC_ROOM,
  RC_ROOM_ADD,
  RC_ROOM_ALL,
  RC_SEND,
  RC_SUBSCRIBE,
  RC_TYPING_RECEIVE,
  RC_USER
} from "../constants/actionTypes"
import {
  checkState,
  getSender,
  getStoredMessages,
  loadHistory,
  register
} from "../actions/rocketChatAction";
import {
  RC_MESSAGE_DIRECT_TYPE,
  RC_MESSAGE_NUMBER,
  RC_MSG_REQUEST_CONNECT,
  RC_MSG_REQUEST_METHOD,
  RC_MSG_REQUEST_PONG,
  RC_MSG_REQUEST_SUBSCRIBE,
  RC_MSG_RESPONSE_ADDED,
  RC_MSG_RESPONSE_CHANGED,
  RC_MSG_RESPONSE_ERROR,
  RC_MSG_RESPONSE_NOSUB,
  RC_MSG_RESPONSE_PING,
  RC_MSG_RESPONSE_REMOVED,
  RC_MSG_RESPONSE_RESULT,
  RC_NOTIFY_ROOM,
  RC_NOTIFY_ROOM_MESSAGE,
  RC_NOTIFY_USER,
  RC_STATUS_OFFLINE,
  RC_SUBSCRIPTION_NOTIFICATION,
  RC_SUBSCRIPTION_TYPING,
  RC_USER_PREFIX_T
} from "../constants";
import createNotification from "../entities/createNotification";
import VideoCallNotification from "../entities/VideoCallNotification";

let socket = null;
let requestNumber = 0;

export const rocketChat = (store) => (next) => (action) => {
    const getRequestNumber = () => {
      requestNumber += 1;
      return requestNumber.toString();
    };

    switch (action.type) {
      case RC_CONNECT:
        socket = new WebSocketAsPromised(
          `wss://${action.token}@${action.domain}/websocket`,
          {
            packMessage: (data) => {
              if ("id" in data && "msg" in data && data.msg === "method") {
                store.dispatch(
                  {
                    type: RC_REQUEST,
                    message: data
                  }
                );
              }

              return JSON.stringify(data);
            },
            unpackMessage: (message) => {
              const data = JSON.parse(message);

              if ("id" in data && "msg" in data && data.msg === "result") {
                store.dispatch(
                  {
                    type: RC_RESPONSE,
                    message: data
                  }
                );
              }

              return data;
            }
          }
        );
        socket
          .onMessage
          .addListener((data) => {

            /**
             * Check messages
             * console.log(data);
             */
          });
        socket
          .onPackedMessage
          .addListener((data) => {
            switch (data.msg) {
              case RC_MSG_RESPONSE_PING:
                store.dispatch(
                  {
                    type: RC_CHECK_STATE,
                    payload: true
                  }
                );
                socket.sendPacked({msg: RC_MSG_REQUEST_PONG});
                break;
              case RC_MSG_RESPONSE_ERROR:
                store.dispatch(
                  {
                    type: RC_ERROR,
                    error: {
                      code: 500,
                      reason: data.reason,
                      message: data.offendingMessage || ""
                    }
                  }
                );
                break;
              case RC_MSG_RESPONSE_ADDED:
                if ("collection" in data &&
                  data.collection === "users" &&
                  "fields" in data
                ) {
                  store.dispatch(
                    {
                      type: RC_USER,
                      user: {
                        id: data.id,
                        ...data.fields
                      }
                    }
                  );
                }
                break;
              case RC_MSG_RESPONSE_REMOVED:
                if ("collection" in data && data.collection === "users") {
                  store.dispatch(
                    {
                      type: RC_USER,
                      user: {
                        id: data.id,
                        status: RC_STATUS_OFFLINE
                      }
                    }
                  );
                }
                break;
              case RC_MSG_RESPONSE_CHANGED:
                if ("collection" in data && "fields" in data) {
                  switch (data.collection) {
                    case "users":
                      store.dispatch(
                        {
                          type: RC_USER,
                          user: {
                            id: data.id,
                            ...data.fields
                          }
                        }
                      );
                      break;
                    case RC_NOTIFY_USER:
                      if ("eventName" in data.fields &&
                        data.fields.eventName.includes(RC_SUBSCRIPTION_NOTIFICATION)
                      ) {
                        if (!(data.fields.args[0].payload.sender.username in store.getState().rocketChat.rooms)) {
                          store.dispatch(
                            {
                              type: RC_ROOM,
                              roomName: data.fields.args[0].payload.sender.username
                            }
                          );
                          store.dispatch(
                            {
                              type: RC_ROOM_ADD,
                              rid: data.fields.args[0].payload.rid
                            }
                          );
                        }

                        store.dispatch(
                          {
                            type: RC_NOTIFICATION,
                            notifications: data.fields.args
                              .filter((notification) => VideoCallNotification
                                .checkVideoActions(store.dispatch, notification) &&
                                store.getState().push.id !== notification.payload._id
                              )
                              .map((notification) => {
                                const sender = store.dispatch(getSender(notification.payload.sender.username));

                                return createNotification(notification, sender);
                              })
                          }
                        );
                      }
                      break;
                    case RC_NOTIFY_ROOM_MESSAGE:
                      if ("eventName" in data.fields &&
                        data.fields.eventName === data.fields.args[0].rid
                      ) {
                        localStorage.messages = JSON.stringify(
                          getStoredMessages().reduce((messages, message) => {
                            if ("rid" in message && !(
                              data.fields.args[0].rid === message.rid &&
                              data.fields.args[0].msg === message.msg
                            )) {
                              messages.push(message)
                            }
                            return messages;
                          }, [])
                        );
                        if (data.fields.args[0].rid in store.getState().rocketChat.messages) {
                          store.dispatch(
                            {
                              type: RC_MESSAGE_NEW,
                              user: store.getState().rocketChat.user.username,
                              message: data.fields.args[0]
                            }
                          );
                        } else {
                          store.dispatch(loadHistory(data.fields.args[0].rid))
                        }
                      }
                      break;
                    case RC_NOTIFY_ROOM:
                      if ("eventName" in data.fields &&
                        data.fields.eventName.includes(RC_SUBSCRIPTION_TYPING)
                      ) {
                        store.dispatch(
                          {
                            type: RC_TYPING_RECEIVE,
                            user: data.fields.args[0],
                            isTyping: data.fields.args[1]
                          }
                        );
                      }
                      break;
                    default:
                  }
                }
                break;
              case RC_MSG_RESPONSE_RESULT:
                if ("error" in data) {
                  if (data.error.error === 403) {
                    store.dispatch(register());
                  } else {
                    store.dispatch(
                      {
                        type: RC_ERROR,
                        error: {
                          code: data.error.error,
                          reason: data.error.reason
                        }
                      }
                    );
                  }
                } else if ("result" in data) {
                  switch (true) {
                    case "id" in data.result:
                      store.dispatch(
                        {
                          type: RC_LOGIN,
                          payload: data.result
                        }
                      );
                      break;
                    case data.result instanceof Array && "t" in data.result[0]:
                      store.dispatch(
                        {
                          type: RC_ROOM_ALL,
                          payload: data.result.filter((room) => {
                            return room.t === RC_MESSAGE_DIRECT_TYPE &&
                              room.name.startsWith(RC_USER_PREFIX_T);
                          })
                        }
                      );
                      break;
                    case "rid" in data.result && !("msg" in data.result):
                      store.dispatch(
                        {
                          type: RC_ROOM_ADD,
                          rid: data.result.rid,
                          reqresId: data.id
                        }
                      );
                      break;
                    case "messages" in data.result:
                      if (data.result.messages.length > 0) {
                        const [message] = data.result.messages;
                        const room = Object
                          .values(store.getState().rocketChat.rooms)
                          .find((roomsItem) => {
                            return message.rid === roomsItem.rid;
                          });
                        const dispatchMessageAll = () => {
                          store.dispatch(
                            {
                              type: RC_MESSAGE_ALL,
                              user: store.getState().rocketChat.user,
                              messages: data.result.messages,
                              unreadNotLoaded: data.result.unreadNotLoaded
                            }
                          );
                        };

                        if (room.unread === data.result.messages.length) {
                          store.dispatch(
                            {
                              type: RC_MESSAGE_UNREAD,
                              room: room,
                              messages: data.result.messages
                            }
                          );
                          if (room.unread > RC_MESSAGE_NUMBER) {
                            dispatchMessageAll();
                          }
                        } else {
                          dispatchMessageAll();
                        }
                      }
                      break;
                    default:
                  }
                }
                break;
              case RC_MSG_RESPONSE_NOSUB:
                if ("error" in data) {
                  store.dispatch(
                    {
                      type: RC_ERROR,
                      error: {
                        code: data.error.error,
                        reason: `error subscription: ${data.error.reason}/`
                      }
                    }
                  );
                }
                break;
              default:
            }
          });
        socket
          .open()
          .then(() => {
            if (socket) {
              socket.sendPacked(
                {
                  msg: RC_MSG_REQUEST_CONNECT,
                  version: "1",
                  support: ["1"]
                }
              );
            }
          })
          .then(() => {
            store.dispatch({type: RC_OPEN});
          })
          .catch(() => {
            store.dispatch({type: RC_DISCONNECT});
          })
          .then(() => {
            store.dispatch(checkState());
          });
        break;
      case RC_SUBSCRIBE:
        if (socket) {
          try {
            socket.sendPacked(
              {
                msg: RC_MSG_REQUEST_SUBSCRIBE,
                id: getRequestNumber(),
                name: action.payload.name,
                params: [
                  action.payload.event,
                  false
                ]
              }
            );
          } catch (exception) {
            store.dispatch({type: RC_DISCONNECT});
          }
        }
        break;
      case RC_METHOD:
        if (socket) {
          try {
            socket.sendPacked(
              {
                msg: RC_MSG_REQUEST_METHOD,
                id: getRequestNumber(),
                ...action.payload
              }
            );
          } catch (exception) {
            store.dispatch({type: RC_DISCONNECT});
          }
        }
        break;
      case RC_DISCONNECT:
        if (socket !== null) {
          socket.close();
        }
        socket = null;
        store.dispatch({ type: RC_CLOSE });
        break;
      case RC_SEND:
        if (socket) {
          try {
            socket.sendPacked(action.payload);
          } catch (exception) {
            store.dispatch({type: RC_DISCONNECT});
          }
        }
        break;
      default:
    }

    return next(action);
};
